import { configureStore } from '@reduxjs/toolkit'
import teamsCacheReducer from './teamsCacheSlice'
import { cacheTeamsForQuery } from './teamsCacheSlice'

const store = configureStore({
  reducer: {
    teamsCache: teamsCacheReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [cacheTeamsForQuery.type],
        ignoredPaths: ['teamsCache.byKey'],
        warnAfter: 128,
      },
    }),
})

export default store
